exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-bottom-hist{\n\t\tborder-bottom: solid 2px #1C869A;\n}\n.check{\n\t\tmargin-top: 2.6em;\n    \tmargin-left: 1em;\n}\n.custom-historico {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 0.4rem 2rem 2rem;\n}\n.show-plus{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n}\n.tables th,.tables td  {\n\t\tborder: none;\n}\n.tables tr:nth-child(even) {\n\t\tbackground-color: rgba(0, 0, 0, 0.05);\n}\n.tables th {\n\t\tbackground-color: #1c869a;\n\t\tcolor:white;\n\t\tpadding: 8px;\n\t\tborder:groove 1px lightgray\n}\n", ""]);

// exports
